export const HERO_CONSTANTS = {
  TAG: "Health & Wellness",
  DATE: "October 23, 2023",
  TITLE: "Exploring the Benefits of Nicotine Pouches",
  DESCRIPTION:
    "Discover how nicotine pouches offer a smoke-free and convenient alternative for nicotine consumption. Learn about their benefits and usage.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/3184470/pexels-photo-3184470.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Nicotine pouches are gaining popularity as a smoke-free and convenient alternative for nicotine consumption. This guide explores the benefits and usage of nicotine pouches, providing insights into their advantages over traditional smoking methods.",
  "From promoting oral health to offering discreet usage, nicotine pouches provide several benefits for those looking to reduce or quit smoking. We'll delve into the science behind nicotine pouches and how they can support a healthier lifestyle.",
  "Whether you're a smoker looking to quit or someone seeking a smoke-free nicotine option, nicotine pouches offer a versatile and accessible solution. Let's explore the potential benefits and applications of nicotine pouches.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Nicotine Pouches",
    content:
      "Nicotine pouches are small, discreet pouches that contain nicotine and other ingredients. They are placed between the gum and upper lip, allowing the nicotine to be absorbed through the oral mucosa. Unlike traditional tobacco products, nicotine pouches do not contain tobacco and are smoke-free.",
  },
  {
    title: "2. Benefits of Nicotine Pouches",
    content:
      "Nicotine pouches offer several benefits, including being smoke-free, discreet, and easy to use. They do not produce smoke or odor, making them a convenient option for use in public places. Additionally, nicotine pouches can help reduce cravings and withdrawal symptoms for those looking to quit smoking.",
  },
  {
    title: "3. How to Use Nicotine Pouches",
    content:
      "Using nicotine pouches is simple and convenient. Place the pouch between your gum and upper lip, and leave it there for the recommended duration, usually 20-30 minutes. The nicotine is gradually released and absorbed, providing a steady dose without the need for smoking.",
  },
  {
    title: "4. Comparing Nicotine Pouches to Other Nicotine Products",
    content:
      "Nicotine pouches offer a smoke-free alternative to traditional nicotine products like cigarettes and vaping. They provide a similar nicotine experience without the harmful effects of smoke inhalation. Additionally, nicotine pouches are more discreet and can be used in various settings.",
  },
  {
    title: "5. Choosing High-Quality Nicotine Pouches",
    content:
      "When selecting nicotine pouches, look for products from reputable brands that use high-quality ingredients. Ensure the pouches are free from artificial additives and contain a clear dosage of nicotine per serving. Reading reviews and checking for third-party testing can also help ensure product quality.",
  },
  {
    title: "6. Potential Side Effects and Precautions",
    content:
      "While nicotine pouches are generally well-tolerated, some individuals may experience mild side effects such as dry mouth or irritation. It's important to follow the recommended usage instructions and consult with a healthcare professional if you have any concerns or underlying health conditions.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/3184471/pexels-photo-3184471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "The Benefits of Switching to Smoke-Free Nicotine Products",
    description:
      "Explore the advantages of switching to smoke-free nicotine products like nicotine pouches. Learn how these alternatives can support a healthier lifestyle.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184472/pexels-photo-3184472.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Quit Smoking with Nicotine Pouches",
    description:
      "Discover practical tips for quitting smoking using nicotine pouches. Follow our guide to understand the benefits and strategies for a successful transition.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184473/pexels-photo-3184473.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Understanding the Science Behind Nicotine Pouches",
    description:
      "Dive into the science of nicotine pouches and how they work. Learn about the potential health benefits and applications of these smoke-free nicotine products.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Discover the Benefits of Nicotine Pouches",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/3184474/pexels-photo-3184474.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 Nicotine Wellness. All rights reserved",
};
